import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "_flexcol _jc-sb" }
const _hoisted_3 = { class: "_flexcol" }
const _hoisted_4 = { class: "_flexrow _gap-2 _tc--accent" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_admin_router_link = _resolveComponent("admin-router-link")
  const _component_base_alert = _resolveComponent("base-alert")

  return (_openBlock(), _createBlock(_component_base_alert, { type: $options.alertType }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "_flexrow _w-100 _jc-sb",
        "data-qa": `performance-marketing-campaign-tip:${$options.typeKey}`
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_admin_router_link, {
              to: $options.campaignRoute,
              enabled: false,
              class: "gfu-hd gfu-hd--h2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.campaignName), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]),
            _createElementVNode("div", null, _toDisplayString($props.message), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_4, [
            ($options.actionRoute)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.actionLabel, (label) => {
                  return (_openBlock(), _createBlock(_component_admin_router_link, {
                    key: label,
                    to: $options.actionRoute,
                    "data-qa": `performance-marketing-campaign-tip-accept`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(label), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("a", {
              class: "gfu-link",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.onHide && $options.onHide(...args))),
              "data-qa": "performance-marketing-campaign-tip-hide"
            }, " hide this information ")
          ])
        ]),
        ($options.badge)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent($options.badge.component), _normalizeProps(_mergeProps({ key: 0 }, $options.badge.props)), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true)
      ], 8 /* PROPS */, _hoisted_1)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["type"]))
}